import React from "react";
import { format } from "date-fns";

function QuitclaimPrint({ object }) {
  const today = format(new Date(), "MMM. dd, yyyy");
  const currentYear = new Date().getFullYear();

  const employee = object?.employee || {};
  const locationObj = object?.location || {};

  const fullName =
    employee.firstName && employee.lastName
      ? `${employee.firstName} ${
          employee.middleName ? employee.middleName + " " : ""
        }${employee.lastName}`
      : "";

  const location = object?.employee?.deployedAt || "";
  const position = employee.position || "";
  const rawAmount = object?.amount || 0;
  const formattedAmount = `₱${Number(rawAmount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  const presentAddressParts = [
    object?.employee?.present_houseNumber,
    object?.employee?.present_street,
    object?.employee?.present_subdivision,
    object?.employee?.present_barangay,
    object?.employee?.present_city,
    object?.employee?.present_province,
    object?.employee?.present_zipCode,
  ];

  const presentAddress = presentAddressParts
    .filter((part) => !!part && part.trim() !== "")
    .join(", ");

  // Common styles
  const styles = {
    container: {
      fontFamily: `"Times New Roman", sans-serif`,
      width: "100%",
      padding: `0 3rem`,
    },
    header: {
      display: `flex`,
      justifyContent: `center`,
      marginTop: `1rem`,
    },
    title: {
      fontWeight: `700`,
      fontSize: `1.2rem`,
      textAlign: "center",
      marginTop: `0.4rem`,
      textDecoration: `underline`,
    },
    label: {
      fontWeight: `500`,
      marginRight: `0.5rem`,
    },
    underline: {
      borderBottom: `1px solid black`,
      padding: `0 0.5rem`,
    },
    paragraph: {
      textIndent: "3rem",
      textAlign: "justify",
      lineHeight: "1.5",
      margin: "1rem 0",
    },
    signature: {
      textAlign: "center",
      marginTop: "2rem",
      width: "50%",
      marginLeft: "auto",
    },
    signatureLine: {
      borderTop: "1px solid black",
      width: "80%",
      margin: "0 auto",
    },
    acknowledgement: {
      marginTop: "-3.8rem",
      textAlign: "left",
      padding: "5rem",
    },
    notaryItems: {
      marginTop: "2rem",
    },
    notaryItem: {
      display: "flex",
      marginBottom: "0rem",
    },
  };

  return (
    <div className="card" style={styles.container}>
      <div style={{ display: `flex`, flexDirection: `column`, width: `90%` }}>
        {/* Logo */}
        <div
          style={{ display: `flex`, width: `100%`, justifyContent: `center` }}
        >
          <img
            style={{ width: `25%`, marginTop: `1rem` }}
            src="/lgstop.png"
            alt="Company Logo"
          />
        </div>

        {/* Header */}
        <div style={styles.header}>
          <div style={{ display: `flex`, flexDirection: `column` }}>
            <p style={{ fontWeight: `700`, textAlign: `center`, margin: `0` }}>
              LGS Centre, 1639 Dian corner Rockefeller St. <br /> Brgy. San
              Isidro, Makati City, 1234 Philippines
            </p>
            <p style={{ fontWeight: `700`, textAlign: `center` }}>
              Telephone Number: (02) 8889-2680
            </p>
          </div>
        </div>

        {/* Title */}
        <div style={styles.title}>
          <p>RELEASE WAIVER AND QUITCLAIM</p>
        </div>

        {/* Form Content */}
        <div style={{ marginTop: `1rem` }}>
          <p style={{ textAlign: "start", fontWeight: "bold" }}>
            KNOW ALL MEN BY THESE PRESENTS:
          </p>

          {/* First paragraph */}
          <p style={styles.paragraph}>
            That I,{" "}
            <span style={{ ...styles.underline, padding: `0 5rem 0 0.5rem` }}>
              {fullName}
            </span>
            , Filipino, of legal age, a resident of{" "}
            <span style={{ ...styles.underline, padding: `0 5rem 0 0.5rem` }}>
              {presentAddress}
            </span>
            , and formerly employed with{" "}
            <strong>LGS STAFF MANAGEMENT SERVICES INC.</strong> assigned in{" "}
            <strong>
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {location}
              </span>
            </strong>{" "}
            for the position of{" "}
            <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
              {position}
            </span>
            , do by these presents acknowledge receipt of the sum of{" "}
            <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
              {formattedAmount}
            </span>
            , Philippine Currency, from LGS in full payment and final settlement
            of the (financial assistance or separation pay, overtime pay,{" "}
            <strong>Final salary or salaries, wage or wages,</strong> commutable
            sick and vacation leaves, gratuities or any kind of compensation or
            emoluments and 13<sup>th</sup> month pay) due to me or which may be
            due to me from LGS under the law or under any existing agreement
            with respect thereto, as well as any and all claims of whatever kind
            and nature which I have or may have against LGS, arising from my
            employment with and the termination of my employment with LGS.
          </p>

          {/* Second paragraph */}
          <p style={styles.paragraph}>
            In consideration of said payment, I do hereby quitclaim, release,
            discharge and waive any and all actions of whatever nature,
            expected, real or apparent, which I may have against LGS, its
            directors, officers, employees, agents and clients by reason of or
            arising from my employment with the company. I will institute no
            action, whether civil, criminal, labor or administrative against
            LGS, its directors, officers, employees, agents and clients. Any and
            all actions which I may have commenced either solely in my name or
            jointly with others before any office, board, bureau, court, or
            tribunal against LGS, its directors, officers, employees, agents and
            clients are hereby deemed and considered voluntary withdrawn by me
            and I will no longer testify or continue to prosecute said
            action(s).
          </p>

          {/* Third paragraph */}
          <p style={styles.paragraph}>
            I declare that I have read this document and have fully understood
            its contents. I further declare that I voluntarily and willingly
            executed this Release, Waiver and Quitclaim with full knowledge of
            my rights under the law.
          </p>

          {/* Witness statement */}
          <p style={styles.paragraph}>
            IN WITNESS WHEREOF, I have hereunto set my hand at{" "}
            <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
              {""}
            </span>
            , this{" "}
            <span style={{ ...styles.underline, padding: `0 1rem 0 0.5rem` }}>
              {""}
            </span>{" "}
            day of{" "}
            <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
              {""}
            </span>
            , 20
            <span style={{ ...styles.underline, padding: `0 1rem 0 0.5rem` }}>
              {/* {currentYear.toString().substring(2)} */}
            </span>
            .
          </p>

          {/* Signature */}
          <div style={styles.signature}>
            <div style={styles.signatureLine}></div>
            <p>Affiant</p>
          </div>

          {/* Acknowledgement section */}
          <div style={styles.acknowledgement}>
            <div
              style={{
                borderTop: "5px dotted black",
                width: "100%",
                marginBottom: "1rem",
              }}
            ></div>
            <p
              style={{
                textAlign: "center",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              ACKNOWLEDGEMENT
            </p>

            <p>
              REPUBLIC OF THE PHILIPPINES)
              <br />
              CITY OF MAKATI ) S.S.
            </p>

            <p style={{ textAlign: "justify", marginTop: "1rem" }}>
              BEFORE ME, a Notary Public, for and in Makati City, Philippines
              personally appeared{" "}
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {""}
              </span>{" "}
              with ID #{" "}
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {""}
              </span>{" "}
              issued at{" "}
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {""}
              </span>{" "}
              on{" "}
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {""}
              </span>{" "}
              known to me to be the same person who executed the foregoing
              Receipt, Release & Quit Claim and acknowledged that same was
              executed on his/her free will & voluntary ACT AND deed.
            </p>

            <p>
              WITNESS MY HAND AND SEAL this{" "}
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {""}
              </span>{" "}
              day of{" "}
              <span style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}>
                {""}
              </span>{" "}
              20
              <span style={{ ...styles.underline, padding: `0 1rem 0 0.5rem` }}>
                {/* {currentYear.toString().substring(2)} */}
              </span>{" "}
              in Makati City Philippines.
            </p>

            <div style={styles.notaryItems}>
              <div style={styles.notaryItem}>
                <span>Doc. No</span>
                <span
                  style={{
                    ...styles.underline,
                    marginLeft: "1rem",
                    width: "8rem",
                  }}
                ></span>
              </div>
              <div style={styles.notaryItem}>
                <span>Page No.</span>
                <span
                  style={{
                    ...styles.underline,
                    marginLeft: "1rem",
                    width: "8rem",
                  }}
                ></span>
              </div>
              <div style={styles.notaryItem}>
                <span>Book No</span>
                <span
                  style={{
                    ...styles.underline,
                    marginLeft: "1rem",
                    width: "8rem",
                  }}
                ></span>
              </div>
              <div style={styles.notaryItem}>
                <span>Series of 20</span>
                <span
                  style={{
                    ...styles.underline,
                    marginLeft: "0.5rem",
                    width: "5rem",
                  }}
                >
                  {/* {currentYear.toString().substring(2)} */}
                </span>
                <span>.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuitclaimPrint;
